import React, { useCallback, useRef } from 'react';
import { MenuItem, SalvMenuButton, Size } from '@salvapp/ui-components';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { useQueryCaseStatuses } from './caseManagementQueryActions';
import { InternalApiCaseStatus } from '../../api-internal';
import useShortcut from '../../common/useShortcut';

interface Props {
  label: string;
  size: Size;
  disabled?: boolean;
  assignedStatusCode?: string;
  icon?: IconDefinition;
  shortcutTriggerKey?: string;
  onStatusSelect: (status: InternalApiCaseStatus) => void;
}

const CaseStatusDropdown = ({
  label,
  size,
  disabled,
  assignedStatusCode,
  icon,
  shortcutTriggerKey,
  onStatusSelect,
}: Props) => {
  const { data: statuses, isPending, isError } = useQueryCaseStatuses();

  const ref = useRef<HTMLButtonElement>(null);
  const openMenu = useCallback(() => {
    ref.current?.click();
  }, [ref]);
  useShortcut({ triggerKey: shortcutTriggerKey, onTrigger: openMenu });

  return (
    <SalvMenuButton
      ref={ref}
      label={label}
      icon={icon}
      size={size}
      disabled={disabled || isPending}
      onAction={([code]) => {
        if (isError || isPending) {
          return;
        }
        onStatusSelect(statuses.find((status) => status.code === code)!);
      }}
    >
      {statuses?.map((status) => (
        <MenuItem
          key={status.code}
          title={status.textName}
          value={status.code}
          disabled={status.code === assignedStatusCode}
        />
      ))}
    </SalvMenuButton>
  );
};

export default CaseStatusDropdown;
